import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

import classnames from 'classnames'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import Select from 'react-select'

import { getMonitorValue } from '../../functions'

import StageplanItem from './stageplan-item'
import StageplanSidebar from './stageplan-sidebar'

class Stageplan extends Component {
  constructor(props) {
    super(props)

    this.state = {
      offset: 300,
      spacing: 18,
      gridSize: 6,
      stageplan: undefined,
      items: undefined,
      itemDefaults: {
        fontSize: 15,
        width: 150,
        height: 50,
        rotation: {
          degrees: 0,
          radians: 0
        }
      },
      focusItem: undefined,
      fontSize: undefined,
      canvas: {
        ratio: 1,
        width: undefined,
        height: undefined
      },
      sidebar: {
        width: undefined,
        height: undefined
      },
      showDropdown: false,
      showDropArea: false,
      dragObject: undefined,
      dragStartOffset: {
        width: 280,
        height: 48,
        x: 0,
        y: 0
      },
      isDragging: false,
      hideAnimation: false
    }
  }

  componentWillMount() {
    const { stageplan, items } = this.props

    this.setState({stageplan, items})
  }

  componentDidMount() {
    const { stageplan } = this.state

    this.calculateStageplanCanvas(stageplan, 'componentDidMount')

    window.addEventListener('resize', () => this.calculateStageplanCanvas(this.props.stageplan, 'addEventListener'))
  }

  componentWillReceiveProps(nextProps) {
    const { view, stageplan, items } = nextProps

    if (stageplan !== this.props.stageplan) this.setState({stageplan})
    if (items !== this.props.items) this.setState({items})
  }

  componentDidUpdate(prevProps, prevState) {
    const { view } = this.props
    const { stageplan } = this.state

    if (view.editable !== prevProps.view.editable) this.calculateStageplanCanvas(stageplan, 'componentDidUpdate') // update component when switched to view_only view (also used for PDF export)
    if (stageplan !== prevState.stageplan) this.calculateStageplanCanvas(stageplan, 'componentDidUpdate')
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.calculateStageplanCanvas(this.props.stageplan, 'removeEventListener'))
  }

  calculateStageplanCanvas = (stageplan, origin) => {
    const { view } = this.props
    const offset = view.editable ? this.state.offset : 0
    const { spacing, itemDefaults } = this.state

    const clientRect = ReactDOM.findDOMNode(this).getBoundingClientRect()

    const ratio = (clientRect.width-offset-(spacing*2))/stageplan.width
    const width = Math.ceil(ratio*100)*(stageplan.width/100)
    const height = Math.ceil(ratio*100)*(stageplan.height/100)

    const sidebarWidth = clientRect.width-width-spacing

    this.setState({
      fontSize: itemDefaults.fontSize*ratio,
      canvas: {
        ratio,
        width,
        height
      },
      sidebar: {
        width: sidebarWidth,
        height
      }
    })
  }

  addStageplanItem() {
    const { view } = this.props
    const { itemDefaults } = this.state

    if (view.editable) {
      this.props.addRiderStageplanItem({
        id: null,
        type: 'custom',
        title: '',
        top: 50,
        left: 50,
        width: itemDefaults.width,
        height: itemDefaults.height,
        rotation: itemDefaults.rotation
      })
    }
  }

  createStageplanItem(sidebarItem, position) {
    const { items, itemDefaults, canvas, dragStartOffset } = this.state

    if (sidebarItem !== undefined) {
      let item = {
        id: null,
        top: position !== undefined ? (position.y+dragStartOffset.y)/canvas.height*100 : 50,
        left: position !== undefined ? (position.x+dragStartOffset.x)/canvas.width*100 : 50,
        width: sidebarItem.width || dragStartOffset.width/canvas.ratio,
        height: sidebarItem.height || dragStartOffset.height/canvas.ratio,
        rotation: sidebarItem.rotation || itemDefaults.rotation,
        params: {shape: sidebarItem.shape}
      }

      if (sidebarItem.id && sidebarItem.name) {
        item = update(item, {
          $merge: {
            type: 'rider_member',
            riderMemberId: sidebarItem.id,
            title: sidebarItem.name,
            width: 100,
            height: 100,
            params: {
              shape: 'oval'
            }
          }
        })
      } else
      if (sidebarItem.id) {
        item = update(item, {
          $merge: {
            type: 'rider_item',
            riderItemId: sidebarItem.id,
            channel: sidebarItem.channel,
            title: sidebarItem.title
          }
        })
      } else {
        item = update(item, {
          $merge: {
            type: 'custom',
            title: sidebarItem.title
          }
        })
      }

      this.setState({
        items: update(items, {$push: [item]})
      }, () => this.props.createRiderStageplanItem(item))
    }
  }

  renderDropdown(item, parentItem) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.props.deleteRiderStageplan(this.props.stageplan.id)}>Remove</li>
            </ul>
          : null
        }
      </div>
    )
  }

  render() {
    const { view, categories } = this.props
    const { spacing, gridSize, stageplan, items, itemDefaults, focusItem, fontSize, canvas, sidebar, showDropArea, isDragging, hideAnimation } = this.state

    const stageSizes = []
    for (let value = 1; value <= 40; value++) stageSizes.push({value})

    const className = (snapshot) => classnames({
      'stageplan-canvas': true,
      'stageplan-canvas--hover': snapshot.isDraggingOver || showDropArea
    })

    return (
      <section className="stageplan section--full" style={{width: '100%', height: 'auto', backgroundSize: `${gridSize}px ${gridSize}px`}}>
        <div className="section-head">
          <h2>Stageplan</h2>

          {
            view.editable
            ? <div className="stage-size">
                Stage size:
                <Select
                  openOnFocus={true}
                  className="react-select"
                  value={{value: parseInt(stageplan.width/100, 10)}}
                  valueKey="value"
                  labelKey="value"
                  clearable={false}
                  placeholder={'Width'}
                  noResultsText={null}
                  onChange={({value}) => this.setState({
                    stageplan: update(stageplan, {
                      width: {$set: value*100}
                    })
                  }, () => {
                    this.props.editRiderStageplan({
                      id: stageplan.id,
                      width: value*100
                    })
                  })}
                  options={stageSizes} />
                x
                <Select
                  openOnFocus={true}
                  className="react-select"
                  value={{value: parseInt(stageplan.height/100, 10)}}
                  valueKey="value"
                  labelKey="value"
                  clearable={false}
                  placeholder={'Height'}
                  onChange={({value}) => this.setState({
                    stageplan: update(stageplan, {
                      height: {$set: value*100}
                    })
                  }, () => {
                    this.props.editRiderStageplan({
                      id: stageplan.id,
                      height: value*100
                    })
                  })}
                  options={stageSizes} />
                metres
              </div>
            : null
          }
        </div>

        <div className="section-content" style={{
          width: `100%`,
          height: `auto`
        }}>
          <DragDropContext
            onDragStart={(start, provided) => {
              const index = start.draggableId
              const category = start.source.droppableId

              let dragObject = undefined

              if (category === 'misc') {
                const categoryIndex = index.split('-')[0]
                const childIndex = index.split('-')[1]

                dragObject = this.props.categories[category][categoryIndex].children[childIndex]
              } else {
                dragObject = this.props.categories[category][index]
              }

              this.setState({
                dragObject,
                showDropArea: true,
                hideAnimation: false
              })
            }}
            onDragUpdate={(update, provided) => console.log({update, provided})}
            onDragEnd={(result, provided, e) => this.setState({dragObject: undefined, showDropArea: false})}>

            <div className="stageplan-droppable-area" style={{margin: `${spacing}px`}}>
              <Droppable droppableId="canvas" isDropDisabled={!view.editable} type="stageplan">
                {(provided, snapshot) => (
                  <div ref={provided.innerRef} className={className(snapshot)}
                    style={{
                      backgroundSize: `${Math.ceil(canvas.ratio*100)}px ${Math.ceil(canvas.ratio*100)}px`,
                      width: `${canvas.width+1}px`,
                      height: `${canvas.height+1}px`
                    }}
                    onDoubleClick={(e) => {
                      if (view.editable) {
                        if (e.nativeEvent.target.className === 'stageplan-canvas') {
                          const x = e.nativeEvent.offsetX
                          const y = e.nativeEvent.offsetY

                          this.props.addRiderStageplanItem({
                            id: null,
                            type: 'custom',
                            title: '',
                            top: (y/canvas.height)*100,
                            left: (x/canvas.width)*100,
                            width: itemDefaults.width,
                            height: itemDefaults.height,
                            rotation: {
                              degrees: '0',
                              radians: '0'
                            }
                          })
                        }
                      }
                    }}
                    onMouseUp={(e) => {
                      const { dragObject } = this.state

                      if (view.editable && dragObject) {
                        this.setState({
                          hideAnimation: true
                        })

                        const position = {
                          x: e.nativeEvent.offsetX,
                          y: e.nativeEvent.offsetY
                        }

                        this.setState({dragObject: undefined}, () => this.createStageplanItem({...dragObject, title: getMonitorValue(dragObject)}, position))
                      }
                    }}>
                    <div className="stageplan-scale" style={{
                      fontSize: `${10*canvas.ratio}px`,
                      width: `${Math.ceil(canvas.ratio*100)}px`,
                      height: `${Math.ceil(canvas.ratio*100)}px`,
                      position: 'absolute'
                    }} />

                    {
                      items.map((item, index) => {
                        return (
                          <div key={item.id || index}>
                            {
                              item.id === null && !item.title
                              ? <div className="riek-escape riek-escape--overlay" onClick={() => this.props.removeRiderStageplanItem(index)} />
                              : null
                            }

                            <StageplanItem
                              view={view}
                              item={item}
                              itemIsFocused={item.id === focusItem ? true : false}
                              canvas={canvas}
                              fontSize={fontSize}
                              setDragState={(state) => this.setState({isDragging: state})}
                              removeRiderStageplanItem={() => this.props.removeRiderStageplanItem(index)}
                              createRiderStageplanItem={(item) => this.setState({
                                items: update(items, {
                                  [index]: {$set: item}
                                })
                              }, () => {
                                this.props.createRiderStageplanItem({
                                  type: 'custom',
                                  title: item.title,
                                  top: item.top,
                                  left: item.left,
                                  width: item.width,
                                  height: item.height,
                                  rotation: {
                                    degrees: '0',
                                    radians: '0'
                                  }
                                })
                              })}
                              editRiderStageplanItem={(item) => this.props.editRiderStageplanItem(item, index)}
                              deleteRiderStageplanItem={this.props.deleteRiderStageplanItem} />
                          </div>
                        )
                      })
                    }

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>

              {
                view.editable
                ? <StageplanSidebar style={{...sidebar, padding: `0 ${spacing}px`}}
                    fontSize={fontSize}
                    categories={categories}
                    isDragging={isDragging}
                    hideAnimation={hideAnimation}
                    setDragStartOffset={(dragStartOffset) => this.setState({dragStartOffset})}
                    setRiderStageplanItemFocus={(focusItem) => this.setState({focusItem})}
                    addRiderStageplanItem={(item) => this.addStageplanItem(item)}
                    createRiderStageplanItem={(item) => this.createStageplanItem(item)} />
                : null
              }
            </div>
          </DragDropContext>
        </div>
      </section>
    )
  }
}

Stageplan.propTypes = {
  view: PropTypes.object,
  stageplan: PropTypes.object,
  items: PropTypes.array,
  categories: PropTypes.object,
  editRiderStageplan: PropTypes.func,
  addRiderStageplanItem: PropTypes.func,
  removeRiderStageplanItem: PropTypes.func,
  createRiderStageplanItem: PropTypes.func,
  editRiderStageplanItem: PropTypes.func,
  deleteRiderStageplanItem: PropTypes.func
}

Stageplan.defaultProps = {
  view: {},
  stageplan: {},
  items: [],
  categories: {},
  editRiderStageplan: function() {},
  addRiderStageplanItem: function() {},
  removeRiderStageplanItem: function() {},
  createRiderStageplanItem: function() {},
  editRiderStageplanItem: function() {},
  deleteRiderStageplanItem: function() {}
}

export default Stageplan



// WEBPACK FOOTER //
// ./src/components/rider/rider-stageplans/stageplan.js